<template>
  <section id="skills" class="skills">
    <div class="skills-container">
      <div class="section-header">
        <h2 class="section-title">My Skills</h2>
        <p class="section-subtitle">Technologies and tools I work with</p>
      </div>
      
      <div class="skills-content">
        <div class="skills-card">
          <div class="skills-grid">
            <div class="skill-item" v-for="skill in allSkills" :key="skill.name">
              <i :class="skill.icon"></i>
              <span class="skill-name">{{ skill.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'SkillsSection',
  data() {
    return {
      allSkills: [
        // Backend Technologies
        { name: 'Laravel', icon: 'fab fa-laravel' },
        { name: 'PHP', icon: 'fab fa-php' },
        { name: 'MySQL', icon: 'fas fa-database' },
        { name: 'PostgreSQL', icon: 'fas fa-database' },
        { name: 'Node.js', icon: 'fab fa-node-js' },
        
        // Frontend Technologies
        { name: 'Vue.js (Quasar + Inertia)', icon: 'fab fa-vuejs' },
        { name: 'JavaScript (ES6+)', icon: 'fab fa-js-square' },
        { name: 'HTML5', icon: 'fab fa-html5' },
        { name: 'CSS3', icon: 'fab fa-css3-alt' },
        { name: 'Bootstrap / Tailwind', icon: 'fab fa-bootstrap' },
        
        // Tools & Development Environment
        { name: 'Git / Bitbucket', icon: 'fab fa-git-alt' },
        { name: 'GitHub', icon: 'fab fa-github' },
        { name: 'VS Code', icon: 'fas fa-code' },
        { name: 'Postman', icon: 'fas fa-paper-plane' }
      ]
    }
  }
}
</script>

<style scoped>
.skills {
  padding: 5rem 0;
  background: #f8f9fa;
}

.skills-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

.section-header {
  text-align: center;
  margin-bottom: 4rem;
}

.section-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 1rem;
}

.section-subtitle {
  font-size: 1.1rem;
  color: #7f8c8d;
  max-width: 600px;
  margin: 0 auto;
}

.skills-card {
  background: white;
  padding: 3rem;
  border-radius: 20px;
  box-shadow: 0 15px 40px rgba(0,0,0,0.1);
  max-width: 900px;
  margin: 0 auto;
}

.skills-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1.5rem;
}

.skill-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 12px;
  transition: all 0.3s ease;
  cursor: pointer;
}

.skill-item:hover {
  background: #3498db;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(52, 152, 219, 0.3);
}

.skill-item i {
  font-size: 1.4rem;
  color: #3498db;
  width: 24px;
  text-align: center;
  transition: color 0.3s ease;
}

.skill-item:hover i {
  color: white;
}

.skill-name {
  font-weight: 500;
  color: #2c3e50;
  font-size: 0.95rem;
  transition: color 0.3s ease;
}

.skill-item:hover .skill-name {
  color: white;
}





/* Responsive */
@media (max-width: 768px) {
  .skills-card {
    padding: 2rem;
    margin: 0 1rem;
  }
  
  .skills-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  
  .section-title {
    font-size: 2rem;
  }
  
  .skill-item {
    justify-content: center;
    text-align: center;
  }
}
</style>
